import { createReducer } from '@reduxjs/toolkit';

import { openAppointmentBookingModal, closeAppointmentBookingModal } from '../../actions';

/**
 * @typedef {boolean} isAppointmentBookingModalOpen
 */

/** @type {isAppointmentBookingModalOpen} */
const initialState = false;

const open = () => true;
const reset = () => false;

export default createReducer(initialState, (builder) => {
  builder
    .addCase(openAppointmentBookingModal, open)
    .addCase(closeAppointmentBookingModal, reset);
});
